export class MenuItem {
    name: string;
    icon: string;
    href: string;
    children: MenuItem[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/menu-item.model.ts